import Head from 'next/head'

import Layout from '../components/Layout'

export default function Tradition(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>
          Robert Karasov - Minneapolis Mohel | History and Traditions
        </title>
      </Head>
      <h1 className="mb-4 text-center text-2xl font-semibold">
        History and Traditions
      </h1>
      <section>
        <div className="space-y-4">
          <p>
            Brit Milah is a 3500 year old Jewish ritual that was first performed
            by our ancestor Abraham. It means the “covenant of circumcision” and
            is often referred to by its Yiddush name as a bris. It is one of the
            most central rituals in Judaism. In the book of Genesis, God
            commanded Abraham to circumcise his son Isaac on the 8th day. We
            learn from this that the obligation to perform a bris falls to the
            father (according to Orthodox Judaism) or to the parents (according
            to Conservative and Reform Judaism). The Mohel acts as an agent of
            the parents. A Mohel is an observant Jew (each movement defines this
            differently) who is trained in the laws of Brit Milah and skilled in
            the performance of circumcision.
          </p>
          <p>
            The 8th day is sacred and the bris is only postponed for the health
            of the baby (or if no Mohel is available). There are many traditions
            for why the 8th day was chosen; however, ultimately it is because
            that is what is written in the Torah. An 8th day bris can be
            performed any day of the year, even on the Sabbath or Yom Kippur.
            However, if a bris has been postponed for health reasons, it cannot
            be performed on the Sabbath or holidays. In addition, if the 8th day
            falls on the Sabbath or a Holiday, as a shomer Shabbat (Sabbath
            observant) Mohel, I still cannot drive to the bris. If this occurs
            we can discuss our options.
          </p>
        </div>
      </section>
    </Layout>
  )
}
